<template>
  <div :class="classnames">
    <template v-if="text">
      <div :class="`${ns}__text`">{{ activeText }}</div>
    </template>

    <div :class="`${ns}__panel`">
      <button :class="`${ns}__button`">{{ buttonLabel }}</button>
    </div>
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'line-clamp'

  export default {
    name: 'LineClamp',
    components: {},
    mixins: [ bem ],
    props: {
      text: {
        type: String
      }
    },
    data: function () {
      return {
        isActive: true
      }
    },
    computed: {
      buttonLabel: function () {
        const buttonLabel = this.isActive ? 'More' : 'Less'

        return buttonLabel
      },
      activeText: function () {
        let activeText = null

        if (this.isActive) {
          activeText = this.shortText
        } else {
          activeText = this.longText
        }

        return activeText
      },
      longText: function () {
        const longText = this.text

        return longText
      },
      shortText: function () {
        let shortText = this.text.substring(0, 100)
        shortText = `${shortText}...`

        return shortText
      }
    },
    watch: {
      'isActive': function () {
        this.emitHeight()
      }
    },
    created: function () {
      this.setNamespace(namespace)
    },
    methods: {
      classnameModifiers: function () {
        const isActive = this.isActive && 'is-active'

        return [
          isActive
        ]
      },
      handleButtonClick: function () {
        this.setState('isActive', !this.isActive)
      },
      emitHeight: function () {
        const that = this

        this.getHeight().then(function (height) {
          that.$emit('heightchange', height)
        })
      },
      getHeight: function () {
        const that = this
        const styleObject = window.getComputedStyle(that.$el)
        const initialHeight = styleObject.height

        const promisedHeight = new Promise(function (resolve) {
          const count = {
            current: 0,
            max: 5
          }

          function countIsAtMax () {
            if (count.current === count.max) {
              return true
            } else {
              return false
            }
          }

          function incrementCount () {
            count.current = count.current + 1
          }

          function hasHeightChanged () {
            const currentHeight = styleObject.height

            if (currentHeight !== initialHeight) {
              return true
            } else {
              return false
            }
          }

          function checkHeightChange () {
            return hasHeightChanged()
          }

          const checkingHeightChange = setInterval(function () {
            const hasHitCountLimit = countIsAtMax()
            const hasHeightChanged = checkHeightChange()

            if (hasHitCountLimit || hasHeightChanged) {
              const newHeight = parseInt(styleObject.height, 10)
              resolve(newHeight)

              clearInterval(checkingHeightChange)
            } else {
              incrementCount()
            }
          }, 10)
        })

        return promisedHeight
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/LineClamp.vue